import { FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useField } from 'formik';
 
export function getCurrentFYStartYear(): number { //returns max financial year 
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth()+1; 
    return month >= 4 ? year : year - 1; 
}

/**
 * Generates financial year options like "2025-2026", "2026-2027"
 * based on minYear and maxYear (start years).
 */
function generateFYOptions(minYear: number, maxYear: number): { label: string; value: string }[] {
    const options = [];
    for (let year = minYear; year <= maxYear; year++) {
        options.push({
            label: `${year}-${year + 1}`,
            value: `${year}-${year + 1}`,
        });
    }
    return options;
}

interface FinancialYearSelectProps {
    name: string;
    /** Start year for FY options (default: 2025) */
    minYear?: number;
    /** Max year - defaults to current FY start year (April-aware) */
    maxYear?: number;
    label?: string;
    disabled?: boolean;
}

export default function FinancialYearSelect({
    name,
    minYear = 2025,
    maxYear = getCurrentFYStartYear(),
    label = '',
    disabled = false,
}: FinancialYearSelectProps): JSX.Element {
    const options = generateFYOptions(minYear, maxYear);
    const [field, meta, helpers] = useField(name);
    const errorText = meta.error && meta.touched ? meta.error : '';

    const handleChange = (e: SelectChangeEvent<string>) => {
        helpers.setValue(e.target.value);
    };

    return (
        <FormControl
            variant="outlined"
            fullWidth
            error={!!errorText}
        >
            <InputLabel>{label}</InputLabel>
            <Select
                value={field.value ?? ''}
                label={label}
                onChange={handleChange}
                onBlur={() => helpers.setTouched(true, true)}
                disabled={disabled}
                sx={{ borderRadius: '10px' }}
            >
                {options.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                    </MenuItem>
                ))}
            </Select>
            {errorText && (
                <FormHelperText error sx={{ marginLeft: 'unset' }}>
                    {errorText}
                </FormHelperText>
            )}
        </FormControl>
    );
}
